import React, { useState, useEffect, useContext } from 'react'
import {
    Tab, Tabs, TabList, TabPanel
} from 'react-tabs'

import AssociacaoProvider from '../../contexts/AssociacaoContext'

import Card from '../../components/Card'

import { Container } from './styles'

import { TipContext } from '../../contexts/TipContext'
import { loadTips } from '../../util/tip'
import { Pessoal } from './Etapas/Pessoal'
import { Contato } from './Etapas/Contato'
import { Endereco } from './Etapas/Endereco'
import { Formacao } from './Etapas/Formacao'

const etapas = [
    {
        posicao: 0,
        label: '1 - Dados pessoais',
        Componente: Pessoal
    },
    {
        posicao: 1,
        label: '2 - Endereço',
        Componente: Endereco
    },
    {
        posicao: 2,
        label: '3 - Formação',
        Componente: Formacao
    }
]

export default function () {
    const { setCodigo } = useContext(TipContext)

    const [tabsStatus, setTabsStatus] = useState([true, false, false, false])
    const [indiceTabAtiva, setIndiceTabAtiva] = useState(0)

    useEffect(() => {
        localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_DADOS_ASSOCIACAO)

        loadTips(setCodigo, 'form_cadastro_talento')
    }, [])

    return (
        <Container>
            <main className="animated fadeIn faster">
                <Card>
                    <h1>Cadastro de Talentos</h1>

                    <Tabs
                        selectedIndex={indiceTabAtiva}
                        onSelect={indiceTab => setIndiceTabAtiva(indiceTab)}
                        className="grid grid-cols-[200px_auto] gap-x-3"
                    >
                        <TabList className="react-tabs flex flex-col bg-[#3a5f61] rounded-md h-fit min-h-[111px] overflow-hidden">
                            {etapas.map(etapa => (
                                <Tab
                                    key={etapa.posicao}
                                    disabled={etapa.posicao > 0 && !tabsStatus[etapa.posicao]}
                                    className="py-2 px-3"
                                    style={{
                                        borderRadius: 0
                                    }}
                                >
                                    {etapa.label}
                                </Tab>
                            ))}
                        </TabList>

                        <AssociacaoProvider
                            avancarEtapa={() => {
                                setIndiceTabAtiva(old => {
                                    const isLast = old === tabsStatus.length - 1

                                    if (!isLast) {
                                        setTabsStatus(old2 => {
                                            const posicao = old + 1

                                            old2[posicao] = true

                                            return old2
                                        })

                                        return old + 1
                                    }

                                    return old
                                })
                            }}
                        >
                            {etapas.map(etapa => (
                                <TabPanel key={etapa.posicao}>
                                    <etapa.Componente />
                                </TabPanel>
                            ))}
                        </AssociacaoProvider>
                    </Tabs>
                </Card>
            </main>
        </Container>
    )
}
